.path {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-1);
  align-items: center;
}

.step {
  display: inline-flex;
  gap: var(--space-1);
  align-items: center;
}

.separator {
  display: inline-flex;
  color: var(--color-text-subtle);
}

/* Chip recipe from the design proposal §8: text stays --color-text (≥ 10.6:1 on the tint). */
.chip {
  --chip-color: var(--color-border-strong);

  display: inline-flex;
  gap: var(--space-1);
  align-items: center;
  block-size: calc(var(--space-6) - var(--space-1) / 2);
  padding-inline: var(--space-2);
  border: var(--border-width) solid color-mix(in oklab, var(--chip-color) 45%, var(--color-surface));
  border-radius: var(--radius-full);
  background: color-mix(in oklab, var(--chip-color) 14%, var(--color-surface));
  color: var(--color-text);
  font-size: var(--text-sm);
  line-height: var(--leading-tight);
  white-space: nowrap;
}

.path[data-size="sm"] .chip {
  block-size: calc(var(--space-5) - var(--space-1) / 2);
  font-size: var(--text-xs);
  font-stretch: var(--font-stretch-condensed);
}

.dot {
  inline-size: var(--space-2);
  block-size: var(--space-2);
  border-radius: var(--radius-full);
  background: var(--chip-color);
}

.chip[data-family="1"] {
  --chip-color: var(--color-family-1);
}

.chip[data-family="2"] {
  --chip-color: var(--color-family-2);
}

.chip[data-family="3"] {
  --chip-color: var(--color-family-3);
}

.chip[data-family="4"] {
  --chip-color: var(--color-family-4);
}

.chip[data-family="5"] {
  --chip-color: var(--color-family-5);
}

.chip[data-family="6"] {
  --chip-color: var(--color-family-6);
}

.chip[data-family="7"] {
  --chip-color: var(--color-family-7);
}

.chip[data-family="8"] {
  --chip-color: var(--color-family-8);
}

.chip[data-family="9"] {
  --chip-color: var(--color-family-9);
}

.chip[data-family="10"] {
  --chip-color: var(--color-family-10);
}

.chip[data-family="11"] {
  --chip-color: var(--color-family-11);
}

.chip[data-family="12"] {
  --chip-color: var(--color-family-12);
}

.chip[data-family="13"] {
  --chip-color: var(--color-family-13);
}

.chip[data-family="14"] {
  --chip-color: var(--color-family-14);
}

.chip[data-family="15"] {
  --chip-color: var(--color-family-15);
}

.chip[data-family="16"] {
  --chip-color: var(--color-family-16);
}

.chip[data-family="17"] {
  --chip-color: var(--color-family-17);
}
